/**
 * Aciclovir drug configuration
 * Indication-agnostic product facts
 */

import type { Drug } from "../types";

export const aciclovirDrug: Drug = {
  id: "aciclovir",
  name: "Aciclovir",
  drugClass: "antiviral (nucleoside analogue)",
  defaultFoodTiming: "May be taken with or without food. Maintain good hydration during treatment.",
  formulations: [
    {
      id: "aciclovir-800-tab",
      type: "tablet_ir",
      strength: 800,
      strengthUnit: "mg",
      dmdCode: "ADD_DM+D_VMP_CODE",
      canCrush: true,
      crushNote: "Tablet may be dispersed in water if swallowing is difficult",
      storageNote: "Store below 25°C",
      prescribedItemId: "83df6ca4-ec3e-4246-b59f-86fb11c1104b",
    },
    {
      id: "aciclovir-400-tab",
      type: "tablet_ir",
      strength: 400,
      strengthUnit: "mg",
      dmdCode: "ADD_DM+D_VMP_CODE",
      canCrush: true,
      crushNote: "Tablet may be dispersed in water if swallowing is difficult",
      storageNote: "Store below 25°C",
      prescribedItemId: "64296431-8925-4261-a2b3-c46e88406883",
    },
    {
      id: "aciclovir-200-tab",
      type: "tablet_ir",
      strength: 200,
      strengthUnit: "mg",
      dmdCode: "ADD_DM+D_VMP_CODE",
      canCrush: true,
      crushNote: "Tablet may be dispersed in water if swallowing is difficult",
      storageNote: "Store below 25°C",
      prescribedItemId: "ab3ed6c0-ee03-4d00-a048-13e912cb5847",
    },
  ],
};
